import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	calendarIconLabel: {
		id: 'software-deployments.date-filter.date-range-picker.date-input.calendar-icon-label',
		defaultMessage: 'Calendar Icon',
		description: 'Label describing the calendar icon',
	},
});
